import Navbar from "../components/Navbar";
import data from "../language.json";
import React, { useContext, useState } from "react";
import languageContext from "../context/language/languageContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {API_URL,FAST_API_URL} from "../api"

const DoctorDetails = () => {
  const { lang } = useContext(languageContext);
  const navigate = useNavigate();
  const [details, setDetails] = useState({
    doctor_name: '',
    doctor_number: '',
    hospital_name: ''
  });

  const handleChange = (e, field) => {
    setDetails(prevDetails => ({
      ...prevDetails,
      [field]: e.target.value
    }));
  };

  const notadddoctor = () => {
    navigate("/ask", { state: { patientUID: details.uid } });
  };

  const submitProfile = async () => {
    try {
      const headerList = {
        "Accept": "*/*",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      };
      await axios.post(
        `${API_URL}/patient_interaction`,
        details,
        { headers: headerList }
      );
      navigate("/ask", { state: { patientUID: details.uid } });
    } catch (error) {
      console.error("Error saving the details: ", error);
      const message =
      error.response?.data?.msg ||
      "Could not save your data, please try again later";
      alert(message);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />
      <div className="max-w-4xl mx-auto p-8 bg-white/80 backdrop-blur-md shadow-2xl rounded-3xl mt-12">
        {/* <h2 className="text-3xl font-bold text-center mb-10 text-gray-800">
            {console.log(lang)}
          {/* {data[lang]["Profile Heading"]} */}
        {/* </h2> */}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {console.log(data, "labg")}
          {data[localStorage.getItem("lang")]["Doctor"].map((item, index) => (
            <div key={index} className="flex flex-col space-y-2">
              <label className="text-gray-700 font-medium tracking-wide">{item.name}</label>
              <input
                type="text"
                required
                className="px-5 py-3 rounded-xl border border-gray-300 bg-white shadow-inner text-gray-700 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-400 transition-all"
                value={details[item.value]}
                onChange={(e) => handleChange(e, item.value)}
                placeholder={`Enter ${item.name}`}
              />
            </div>
          ))}
        </div>

        {/* Button Section */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mt-12">
          <button
            type="button"
            className="bg-gradient-to-r from-teal-500 to-blue-500 hover:from-teal-600 hover:to-blue-600 text-white font-semibold py-3 px-8 rounded-full shadow-md hover:scale-105 transition-transform"
            onClick={submitProfile}
          >
            Proceed
          </button>

          <button
            type="button"
            className="bg-gradient-to-r from-teal-500 to-blue-500 hover:from-teal-600 hover:to-blue-600 text-white font-semibold py-3 px-8 rounded-full shadow-md hover:scale-105 transition-transform"
            onClick={notadddoctor}
          >
            Skip for Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default DoctorDetails;
